module.exports = __webpack_public_path__ + "img/info.c1e91a43.svg";